import { Pipe, PipeTransform } from "@angular/core";
import { Nillable } from "../types/nillable";
import { numberedName } from "../utils/numbered-name";

@Pipe({
  name: "numbered",
})
export class NumberedPipe implements PipeTransform {
  transform(name: string, number: Nillable<number>): string {
    return numberedName(name, number);
  }
}
